/**
 * The function returns an object with initial values for a quick quote form.
 */
export default function getQuickQuoteInitialValues() {
  return {
    proposer_first_name: "",
    gender: "",
    // dob: "",
    // pincode: "",
    proposer_occupation: "",
    // mobile_number: "",
    proposer_annual_income: "",
    proposer_sum_insured: "",
    insureds: [
      {
        relationship_with_proposer: "",
        first_name: "",
        // dob: "",
        // salutation: "",
        occupation: "",
        // sum_insured: "",
        annual_income: "",
      },
    ],
  };
}
